import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import {
  HeaderContext,
  injectFlexRenderContext
} from '@tanstack/angular-table';

@Component({
  template: `
    <mat-checkbox
      [checked]="context.table.getIsAllRowsSelected()"
      [indeterminate]="context.table.getIsSomeRowsSelected()"
      (change)="context.table.toggleAllRowsSelected()"
    ></mat-checkbox>
  `,
  styleUrls: ['./datatable-head-selection.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatCheckboxModule]
})
export class DatatableHeadSelectionComponent<T = unknown> {
  context = injectFlexRenderContext<HeaderContext<T, unknown>>();
}
